import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import App from './components/App';
import './index.css';

ReactDOM.render(
  	<App />,
  	document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx